import { jsx as _jsx } from "react/jsx-runtime";
import { FormikInput } from "@air/formik-input";
import { Form, Formik } from "formik";
import { useEffect, useRef } from "react";
import { object, string } from "yup";
const VALIDATION_SCHEMA = object().shape({
    name: string().required("Name is required")
});
export const BoardSelectCreateInput = (param)=>{
    let { onBlur, onSubmit } = param;
    const inputRef = useRef(null);
    useEffect(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, []);
    return /*#__PURE__*/ _jsx(Formik, {
        initialValues: {
            name: ""
        },
        onSubmit: (values)=>onSubmit(values.name),
        validationSchema: VALIDATION_SCHEMA,
        children: /*#__PURE__*/ _jsx(Form, {
            /**
         * The `2px` y padding is to prevent the input focus border from being cut
         * off by the list item hover state.
         */ className: "py-0.5",
            children: /*#__PURE__*/ _jsx(FormikInput, {
                "data-1p-ignore": true,
                className: "w-full",
                onBlur: onBlur,
                name: "name",
                ref: inputRef,
                type: "text"
            })
        })
    });
};
